import turn from '../../../assets/turnos.webp'
import { Link } from 'react-router-dom'


const Turnos = ():JSX.Element => {
      return (
        <div className='flex flex-col bg-white w-4/5 sm:h-auto h-auto rounded-t-xl mb-4'>
             
              <div>
              <img className='w-full h-60 rounded-t-xl' src={turn} alt='turnos' />
              </div>
              
              <div className='ml-4 mt-2 mb-2'>
                <h1 className='sm:text-[28px] text-[20px] mb-1 font-roboto font-medium'>AGENDAR TURNO</h1>
                <h4 className='font-roboto'><span className='text-background_home text-[18px]'>Lunes</span>, <span className='text-background_home text-[18px]'>Miecoles</span> y <span className='text-background_home text-[18px]'>Viernes</span> de 8am a 13pm</h4>
                <h4 className='font-roboto'><span className='text-background_home text-[18px]'>Martes</span> y <span className='text-background_home text-[18px]'>Jueves</span> de 8am a 13pm y de 18pm A 20pm</h4>
              </div>
            <Link to='/turnero'>
              <button className='bg-background_home rounded-xl ml-4 h-8 sm:w-1/4 w-1/2 mb-3 sm:mt-12 mt-0 sm:pb-0 text-white'>TURNOS</button>
            </Link>

        </div>
      )
}


export default Turnos